import { StepCardProps } from '@/components/StepsSection/StepCard';

export const stepsData: StepCardProps[] = [
  {
    image: '/jackpot/howToWin/step1.png',
    title: 'jackpot:howToWin.steps.1.title',
    text: 'jackpot:howToWin.steps.1.text',
  },
  {
    image: '/jackpot/howToWin/step2.png',
    title: 'jackpot:howToWin.steps.2.title',
    text: 'jackpot:howToWin.steps.2.text',
  },
  {
    image: '/jackpot/howToWin/step3.png',
    title: 'jackpot:howToWin.steps.3.title',
    text: 'jackpot:howToWin.steps.3.text',
  },
];
